import createOperatingPlanM15Context from 'contexts/OperatingPlanM15';

export const [useOperatingPlanM15Context, OperatingPlanM15Provider] =
  createOperatingPlanM15Context();
